import React, { useContext } from 'react';
import { Card, CardHeader, CardContent, Divider, TextField, Grid, Container, Avatar, Box, Typography } from '@mui/material';
import { ContextSession } from "../../services/ContextSession";
import { useMediaQuery } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Lottie from 'react-lottie-player';
import userLottie from '../img/user.json'

export default function MiPerfil() {
    const isMobile = useMediaQuery('(max-width:820px)'); // Detectar si es una pantalla móvil
    const sessi = useContext(ContextSession);

    return (
        <Container style={{ marginTop: isMobile ? 20 : 50, paddingBottom: 40 }}>
            <Card
                style={{
                    padding: isMobile ? 20 : 40,
                    borderRadius: 16,
                    boxShadow: '0px 8px 24px rgba(0,0,0,0.1)',
                    backgroundColor: 'var(--color-white)',
                }}
            >
                <Box display="flex" alignItems="center" flexDirection="column" mb={3}>

                    <Lottie loop animationData={userLottie} play style={{ width: '20%', height: 'auto' }} />

                    <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: 8 }}>
                        Mi Perfil
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        Información del Usuario
                    </Typography>
                </Box>

                <Divider style={{ marginBottom: 24 }} />

                <CardContent>
                    <Grid container spacing={isMobile ? 2 : 3}>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Nombre de Usuario"
                                name="usuario"
                                defaultValue={sessi.sessionData.usuario}
                                variant="outlined"
                                InputProps={{
                                    readOnly: true,
                                }}
                                style={{
                                    backgroundColor: '#f9f9f9',
                                    borderRadius: 8,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Nombre"
                                name="nombre"
                                defaultValue={sessi.sessionData.nombre}
                                variant="outlined"
                                InputProps={{
                                    readOnly: true,
                                }}
                                style={{
                                    backgroundColor: '#f9f9f9',
                                    borderRadius: 8,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Identidad"
                                name="identidad"
                                defaultValue={sessi.sessionData.identidad}
                                variant="outlined"
                                InputProps={{
                                    readOnly: true,
                                }}
                                style={{
                                    backgroundColor: '#f9f9f9',
                                    borderRadius: 8,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Correo Electrónico"
                                name="correo"
                                defaultValue={sessi.sessionData.email}
                                variant="outlined"
                                InputProps={{
                                    readOnly: true,
                                }}
                                style={{
                                    backgroundColor: '#f9f9f9',
                                    borderRadius: 8,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Teléfono"
                                name="telefono"
                                type="tel"
                                defaultValue={sessi.sessionData.telefono}
                                variant="outlined"
                                InputProps={{
                                    readOnly: true,
                                }}
                                style={{
                                    backgroundColor: '#f9f9f9',
                                    borderRadius: 8,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Estado del Participante"
                                name="estado"
                                defaultValue={sessi.sessionData.estado}
                                variant="outlined"
                                InputProps={{
                                    readOnly: true,
                                }}
                                style={{
                                    backgroundColor: '#f9f9f9',
                                    borderRadius: 8,
                                }}
                            />
                        </Grid>
                    </Grid>
                </CardContent>

                <Divider style={{ marginTop: 24 }} />
            </Card>
        </Container>
    );
}

